import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[baseFilterFullRowItem]',
    standalone: false
})
export class BaseFilterFullRowItemDirective {
  private active = true;

  @Input()
  set baseFilterFullRowItem(value: boolean | string | null | undefined) {
    this.active = coerceBooleanProperty(value);
  }

  @HostBinding('class.base-filter-full-row-item')
  get applyClass(): boolean {
    return this.active;
  }
}
